/* Avatar — matches Figma Avatar (node 1133:4829).
 *
 * Fixed 28×28px circle. Two modes: initials (colored bg + fg) and
 * image (full-bleed <img>). No size variant (YAGNI — Figma fixes 28px).
 * Theme switching via [data-theme="dark"] parent selector — NOT a prop. */

.avatar {
  /* Fixed 28×28 circle. flex-shrink:0 prevents squashing when nested
   * in a flex row next to sender name text. */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: var(--radius-circle);
  box-sizing: border-box;
  overflow: hidden;
  flex-shrink: 0;
}

/* ─── Image mode ─────────────────────────────────────────────────── */

.img {
  /* Full-bleed: stretch to cover the 28×28 circle regardless of the
   * image's natural aspect ratio. object-fit:cover crops to fill. */
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* ─── Initials mode ──────────────────────────────────────────────── */

/* Figma spec: 12px SemiBold, 20px line-height, --text-xs-tracking.
 * --text-micro-semibold resolves to `600 12px/20px "Google Sans Flex"`,
 * which matches exactly. */
.initialsText {
  font: var(--text-micro-semibold);
  letter-spacing: var(--text-xs-tracking);
  /* Guard against extra-long strings — clip, never wrap or overflow. */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: clip;
  /* Prevent the span from growing past the container. Needed because
   * the parent is inline-flex and the span is its only child. */
  max-width: 100%;
}

/* ─── Color variants ─────────────────────────────────────────────── */
/* Each color has a light bg + fg pair and a dark bg + fg pair.
 * Light-mode values are set on the class directly; dark-mode values
 * override under [data-theme="dark"].
 *
 * All six colors follow the same shade pattern across themes:
 *   light: bg=*-200, fg=*-600
 *   dark:  bg=*-300, fg=*-700
 *
 * The 5-color AVATAR_PALETTE used by the hash helper is
 * [violet, fuchsia, amber, lime, sky] (see Notification/avatarColor.ts).
 * `green` is kept here as a supported consumer prop for back-compat
 * but is no longer hash-selected — it sat too close to the emerald
 * brand color.
 */

.color-violet {
  background: var(--violet-200);
  color: var(--violet-600);
}

.color-green {
  background: var(--green-200);
  color: var(--green-600);
}

.color-lime {
  background: var(--lime-200);
  color: var(--lime-600);
}

.color-fuchsia {
  background: var(--fuchsia-200);
  color: var(--fuchsia-600);
}

.color-amber {
  background: var(--amber-200);
  color: var(--amber-600);
}

.color-sky {
  background: var(--sky-200);
  color: var(--sky-600);
}

[data-theme="dark"] .color-violet {
  background: var(--violet-300);
  color: var(--violet-700);
}

[data-theme="dark"] .color-green {
  background: var(--green-300);
  color: var(--green-700);
}

[data-theme="dark"] .color-lime {
  background: var(--lime-300);
  color: var(--lime-700);
}

[data-theme="dark"] .color-fuchsia {
  background: var(--fuchsia-300);
  color: var(--fuchsia-700);
}

[data-theme="dark"] .color-amber {
  background: var(--amber-300);
  color: var(--amber-700);
}

[data-theme="dark"] .color-sky {
  background: var(--sky-300);
  color: var(--sky-700);
}
